export enum EnumStatusMesa {
    INVALIDO = 0,
    ATIVO = 1,
    INATIVO = 2,
}